import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-panel-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="panel-header__title">{{ title() }}</span>
    <div class="panel-header__actions">
      <ng-content select="[action]" />
    </div>
  `,
  styleUrl: './panel-header.component.scss',
})
export class PanelHeaderComponent {
  title = input.required<string>();
}
